import { render } from "./product-stock-message.vue?vue&type=template&id=6531619c"
import script from "./product-stock-message.vue?vue&type=script&lang=js"
export * from "./product-stock-message.vue?vue&type=script&lang=js"

import "./product-stock-message.vue?vue&type=style&index=0&id=6531619c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__